import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { NotificationMessage, NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent implements OnInit, OnDestroy {
  messages: NotificationMessage[] = [];
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly notifications: NotificationService) {}

  ngOnInit(): void {
    this.notifications.messages$
      .pipe(takeUntil(this.destroy$))
      .subscribe((message) => this.push(message));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  dismiss(index: number): void {
    this.messages.splice(index, 1);
  }

  private push(message: NotificationMessage): void {
    this.messages = [...this.messages, message].slice(-4);
    const index = this.messages.length - 1;
    setTimeout(() => this.dismiss(index), 3500);
  }
}
